module.exports = __webpack_public_path__ + "img/head.363b95e9.png";